"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _hoc["default"];
  }
});
exports.container = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _styledSystem = require("styled-system");

var _measures = require("../../theme/measures");

var _styles = require("../../styles");

var _hoc = _interopRequireDefault(require("./hoc"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  width: auto;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var container = (0, _styledComponents.css)(_templateObject(), _styledSystem.space, _styledSystem.width, _styledSystem.justifyContent, _styledSystem.alignItems, function (props) {
  if (props.height) return (0, _styles.buttonHeight)(props);else if (props.size) return (0, _styles.iconHeight)(props);
});
exports.container = container;
container.propTypes = _objectSpread({}, _styledSystem.space.propTypes, {
  type: _propTypes["default"].string,
  name: _propTypes["default"].string,
  color: _propTypes["default"].string,
  stroke: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(Array.from(_measures.ICON_SIZE.keys()))])
});
container.defaultProps = {
  type: 'default',
  size: 'default'
};